module.exports = __webpack_public_path__ + "static/media/cover-fb-totul-pentru-educatie.84fb2bdf.jpg";